import { IS_IOS, IS_ANDROID, IS_MITRA_ANDROID } from 'shared/helpers/userAgentHelper';
import { IS_IOS as BMONEY_IOS, IS_ANDROID as BMONEY_ANDROID } from 'lib/bmoney/helpers/userAgentHelper';
import isMobile from 'shared/mixins/isMobile';

const Tracker = () => {
  let instance;

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line
    instance = require('@bukalapak/tracker-js').default;
    instance.config({
      baseUrl: 'https://t.bukalapak.com',
      dev: process.env.NODE_ENV !== 'production',
      platform:
        (IS_IOS && 'ios') ||
        (BMONEY_IOS && 'bmoney_ios') ||
        (IS_ANDROID && 'android') ||
        (BMONEY_ANDROID && 'bmoney_android') ||
        (IS_MITRA_ANDROID && 'mitra') ||
        (isMobile && 'mweb') ||
        'desktop',
    });
  }

  return instance;
};
export default new Tracker();
